module.exports = __webpack_public_path__ + "img/iskall85-dcc5fb23-1848-407d-41d9-08d9582e9481.png";